import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqIsAllowAccessGroupView = async function(userId, groupId) {

  const app = firebase.app();
  const functions = getFunctions(app, 'asia-east2');
  const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

  const result = await queryThaisookViewBigQuery({
    info: 'check is allowed access group view',
    query: `
      WITH data as (
          select
            GM.groupId id,
            G.name,
            G.description
          from
            thaisook_view.group_members GM
            join 
            thaisook_view.groups G
              on G.groupId = GM.groupId
          where
            GM.uid='${userId}'
            and GM.groupId = '${groupId}'
            and GM.admin = true
        
          UNION ALL
        
          select
            G.groupId id,
            G.name,
            G.description
          from
            thaisook_view.groups G
          where
            G.owner = '${userId}'
            and G.groupId = '${groupId}'
        )
        select distinct id, name, description from data;
      `
  });
  const resultObj = JSON.parse(result.data);
  return resultObj.length ? true : false;  
};
export default bqIsAllowAccessGroupView;
